import React, { useState } from "react";
import withStyles from "@material-ui/styles/withStyles";
import {
  Divider,
  Typography,
  Grid,
  Button,
  IconButton,
} from "@material-ui/core";

import { styles } from "./ZoneItem.styles.js";
import BoxItem from "../Box/BoxItem.js";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";

function ZoneItem({
  classes,
  selectedProject,
  zone,
  onEditZone,
  onDeleteZone,
  onAddBox,
  onEditBox,
  onDeleteBox,
  onSensorSelected,
  onAddSensor,
}) {
  const [hover, sethover] = useState(false);
  //console.log("zone: %o", zone);
  return (
    <div
      className={classes.root}
      onMouseOver={() => sethover(true)}
      onMouseOut={() => sethover(false)}
    >
      <Typography variant="h2" className={classes.title}>
        {zone.designation}{" "}
        <IconButton
          aria-label="edit"
          disableRipple
          size="small"
          onClick={onEditZone}
          className={classes.icon}
          style={hover ? { display: "inline" } : { display: "none" }}
          // style={{ display: "inline" }}
        >
          <EditIcon fontSize="small" />
        </IconButton>
        <IconButton
          aria-label="edit"
          disableRipple
          size="small"
          onClick={() => onDeleteZone(zone)}
          className={classes.icon}
          style={hover ? { display: "inline" } : { display: "none" }}
          // style={{ display: "inline" }}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
      </Typography>
      <Typography variant="h6" className={classes.description}>
        {zone.description}
      </Typography>
      <Grid container spacing={1}>
        {Array.isArray(zone.boxs) && zone.boxs.map((box) => (
          <Grid item xs={12} sm={6} key={box.id}>
            <BoxItem
            selectedProject={selectedProject}
              box={box}
              onEditBox={onEditBox}
              onDeleteBox={onDeleteBox}
              onSensorSelected={onSensorSelected}
              onAddSensor={onAddSensor}
            />
          </Grid>
        ))}
        <Grid item xs={12} sm={6}>
          <Button
            variant="contained"
            size="small"
            color="secondary"
            onClick={() => onAddBox(zone.id)}
          >
            Add New Box
          </Button>
        </Grid>
      </Grid>

      <Divider className={classes.divider} />
    </div>
  );
}

export default withStyles(styles)(ZoneItem);
